<template>
    <div class="buy-group-vip-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="buy-group-vip-content mask-content">
            <span class="close-icon" @click="close"></span>
            <div class="dialog-title" v-if="afterPaySuccShowContent === 1">开通会员 免费畅玩</div>
            <div class="order-info-wrap">
                <div class="goods-info">
                    <div class="icon" v-if="showVipGoodsIcon(currentChoosedVipGoods) === 'vip1'"></div>
                    <div class="inner" :class="[`${showVipGoodsIcon(currentChoosedVipGoods)}`]">
                        <div class="dv1">
                            {{ currentChoosedVipGoods.name }}
                        </div>
                        <div class="dv2">
                            <!-- 优先按照"原价展示渠道"逻辑展示价格 -->
                            <template v-if="currentChoosedVipGoods.showOriginPrice">
                                <span class="sp1">
                                    <i class="i0">仅售</i>
                                    <i class="i1">¥</i>
                                    <i class="i2">{{ currentChoosedVipGoods.original_price }}</i>
                                </span>
                            </template>
                            <template v-else>
                                <span class="sp1">
                                    <i class="i0">仅售</i>
                                    <i class="i1">¥</i>
                                    <i class="i2">{{ currentChoosedVipGoods.current_price }}</i>
                                </span>
                                <span class="sp2" v-if="currentChoosedVipGoods.original_price * 100 !== currentChoosedVipGoods.current_price * 100 && currentChoosedVipGoods.original_price * 100 > currentChoosedVipGoods.current_price * 100">
                                    <i>原价</i>
                                    <i>{{ currentChoosedVipGoods.original_price }}</i>
                                </span>
                            </template>
                        </div>
                        <!-- <div class="dv4">全场游戏免费畅玩尊享{{ currentChoosedVipGoods.name }}</div> -->
                    </div>
                </div>
                <div class="price-info">
                    <div class="dv1">开通会员 免费畅玩</div>
                    <div class="dv2">
                        <template>
                            <span class="sp1" v-if="type === 2">拼团优惠</span>
                            <span class="sp2">
                                <i class="i0">¥</i>
                                <i class="i1">{{ type === 2 ? currentChoosedVipGoods.group_price : currentChoosedVipGoods.current_price }}</i>
                            </span>
                        </template>
                        <span class="sp3">
                            <i>¥</i>
                            <i> {{ type == 2 ? currentChoosedVipGoods.current_price : currentChoosedVipGoods.original_price }}</i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="pay-section" v-if="afterPaySuccShowContent === 1">
                <div class="pay-left">
                    <div class="qrcode-wrap">
                        <div class="qrcode-section">
                            <div class="goods-qrcode" ref="goods-qrcode"></div>
                        </div>
                        <div class="qrcode-loading" v-if="loading">
                            <span class="icon"></span>
                        </div>
                        <div class="qrcode-succ" v-if="payStatus == 'succ'">
                            <div class="dv1">支付成功</div>
                        </div>
                        <div class="qrcode-invalid" v-if="payStatus == 'fail'">
                            <div class="dv1">二维码已失效</div>
                            <div class="dv2" @click="payAgain">刷新</div>
                        </div>
                    </div>
                </div>
                <div class="pay-right">
                    <div class="pay-icon-wrap">
                        <div class="dv1">
                            <span>支持</span>
                            <span class="icon zfb-icon" v-if="zfb"></span>
                            <span class="icon wx-icon" v-if="wx"></span>
                            <span>扫码支付</span>
                        </div>
                    </div>
                    <div class="price-wrap">
                        <span class="sp0">同意并支付</span>
                        <span class="sp1">¥</span>
                        <span class="sp2">
                            <template v-if="type === 1">
                                {{ currentChoosedVipGoods.showOriginPrice ? currentChoosedVipGoods.original_price : currentChoosedVipGoods.current_price }}
                            </template>
                            <template v-else>{{ currentChoosedVipGoods.group_price }}</template>
                        </span>
                    </div>
                    <div class="agree">
                        <i class="i1">已阅读并同意</i>
                        <a class="a1" target="_blank" :href="payAgreement">付费服务协议</a>
                        <span>|</span>
                        <a class="a1" target="_blank" :href="customerLink">联系客服</a>
                        <span>|</span>
                        <a class="a1" target="_blank" @click="watchOrder">查看订单</a>
                    </div>
                </div>
            </div>
            <!-- 拼团订单倒计时 -->
            <div class="group-vip-order" v-else-if="afterPaySuccShowContent === 2">
                <div class="dv1">邀请<span>1</span>名好友，即可团购成功</div>
                <div class="countdown">
                    <span class="sp1">{{ countdownStr.slice(0, 2) }}</span>
                    <span class="sp2">:</span>
                    <span class="sp1">{{ countdownStr.slice(2, 4) }}</span>
                    <span class="sp2">:</span>
                    <span class="sp1">{{ countdownStr.slice(4) }}</span>
                    <span class="sp3">后结束</span>
                </div>
                <div class="invite-info">
                    <div class="item1">
                        <img v-if="avatar(1)" :src="avatar(1)" alt="用户头像" />
                        <div class="icon">团长</div>
                    </div>
                    <div class="item2">
                        <img v-if="avatar(2)" :src="avatar(2)" alt="用户头像" />
                    </div>
                </div>
                <template v-if="order_status === 1">
                    <div class="share-btn" v-if="leftTime > 0 && !showShareLink" @click="handlerClickShareBtn">生成分享链接</div>
                    <div class="share-link-section" @click="copyLink" v-if="showShareLink">{{ shareLink }}<span class="copy-btn">复制</span></div>
                </template>
            </div>
            <!-- 拼团成功 -->
            <div class="group-succ" v-else-if="afterPaySuccShowContent === 3">
                <template v-if="judgeEnv === 'box_website'">
                    <div class="text text1">恭喜你与好友<span>拼团成功</span>，</div>
                    <div class="text">请下载客户端立即开始游戏吧！</div>
                    <div class="dl-btn" @click="dlBox" data-agl-cvt="6">下载客户端</div>
                </template>
                <template v-else>
                    <div class="text text1">恭喜你与好友<span>拼团成功</span>，</div>
                    <div class="text">立即开始游戏吧！</div>
                </template>
            </div>
            <!-- 拼团失败 -->
            <div class="group-fail" v-else-if="afterPaySuccShowContent === 4">
                <div class="text text1">
                    很遗憾您的本轮拼团失败，页面将在<span>【{{ refreshTime }}秒】</span>后刷新
                </div>
                <div class="text">请可重新开团！</div>
            </div>
            <!-- 用户参加自己分享的团 -->
            <div class="my-own-group" v-else-if="afterPaySuccShowContent === 5">
                <div class="text text1">同一账号无法自己成团，</div>
                <div class="text">请将链接分享给好友使用！</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Decimal } from 'decimal.js'
import { mapGetters, mapState } from 'vuex'
import config from '@/http/config'
import QRCode from 'qrcodejs2'
import { cancelRequest } from '@/http'
import { getCookieToken } from '@/utils/auth'
import { createVipOrder, queryOrderStatus } from '@/http/api/order'
import { getUserGroupInfo, getGroupInfo } from '@/http/api/activity'
import { formatTime2 } from '@/utils/date'

export default {
    name: 'BuyGroupVip',
    data() {
        return {
            orderStatus: [1, 2, 3, 4, 5, 6], // 以下状态的订单不可以再次开团
            isShow: false,
            type: -1, // 1--直接购买 2--拼团购买
            currentChoosedVipGoods: {},
            payStatus: '',
            loading: true,
            showBlank: false,
            wx: true,
            zfb: true,
            queryTimes: 0, // 查询订单次数
            errorTimes: 0, // 重试次数
            group_id: 0,
            afterPaySuccShowContent: -1, // 1--拼团订单和非拼团订单支付中状态 2--拼团订单倒计时状态 3--拼单成功状态
            userGroupInfo: {}, // 用户的拼团信息
            defautlAvatar: require('@/assets/default.png'),
            moreDefautlAvatar: require('@/assets/dialog/more-join-avatar.png'),
            leftTime: 0, // 拼团剩余时间
            countdownStr: '000000',
            showShareLink: false,
            queryGroupInfoTimes: 0,
            refreshTime: 15,
            order_status: -1
        }
    },
    computed: {
        ...mapState(['userInfo', 'serverTime', 'payAgreement', 'landpageGameName', 'clientInfo']),
        ...mapGetters(['customerLink']),
        showVipGoodsIcon() {
            return (item) => {
                let className = ''
                if (!item.name) {
                    className = ''
                } else if (item.name.indexOf('永久会员') > -1) {
                    className = 'vip1'
                } else if (item.name.indexOf('365天会员') > -1) {
                    className = 'vip2'
                } else if (item.name.indexOf('30天会员') > -1) {
                    className = 'vip3'
                }
                return className
            }
        },
        subsidyPrice() {
            return (item) => {
                if (!item.id) {
                    return 0
                }
                const payPrice = item.showOriginPrice ? item.original_price : item.current_price
                return Math.abs(new Decimal(payPrice).minus(new Decimal(item.group_price)).toNumber())
            }
        },
        avatar: function () {
            return (type) => {
                // type 1--开团的人头像 2--参团的人头像（存在多个参团人）
                const joinUserInfoList = this.userGroupInfo?.latest_main?.join_list?.filter((v) => this.orderStatus.indexOf(v.order_status)) || []
                if (type === 2 && !joinUserInfoList.length) {
                    return ''
                }
                let avatar = ''
                if (type === 1) {
                    avatar = this.userGroupInfo.latest_main?.avatar
                } else if (joinUserInfoList.legnth === 1) {
                    avatar = joinUserInfoList[0].avatar
                }

                if (!avatar) {
                    if (joinUserInfoList.legnth > 1) {
                        return this.moreDefautlAvatar
                    }
                    return this.defautlAvatar
                } else if (avatar.indexOf('thirdwx.qlogo.cn') > -1) {
                    return avatar
                } else {
                    return config.PREVIEW_DOMAIN + avatar
                }
            }
        },
        // 分享链接
        shareLink() {
            const group_id = this.userGroupInfo?.latest_main?.id || 0
            const name = this.currentChoosedVipGoods.name || ''
            const group_price = this.currentChoosedVipGoods.group_price || 0
            return `${config.BOX_WEBSITE_DOMAIN}/group?group_id=${group_id} 【仅剩1个名额，一起团${name}免费畅玩，2人成团到手价${group_price}元】`
        },
        // 当前环境判断
        judgeEnv() {
            const { client_id = '' } = this.clientInfo
            if (!client_id) {
                return 'box_website'
            } else {
                return 'box'
            }
        }
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('buy-group-vip-page')
                })
            }
        },
        serverTime: {
            immediate: true,
            handler(newVal) {
                const { latest_main = {} } = this.userGroupInfo
                const { start_time, expire_time } = latest_main
                if (start_time && expire_time) {
                    this.leftTime = Math.ceil((+new Date(expire_time) - newVal * 1000) / 1000)
                    // 倒计时多加5分钟，因为订单创建后，二维码有5分钟的有效期
                    const showTime = Math.max(0, this.leftTime + 5 * 60)
                    this.countdownStr = formatTime2(showTime)
                }
            }
        },
        order_status: {
            immediate: true,
            async handler(newVal) {
                if (newVal > -1) {
                    // 订单状态变更了，重新获取用户的拼团信息（延时更新）
                    await this.$Utils.sleep(1500)
                    this.getUserGroupInfo('no-query')
                }
            }
        }
    },
    methods: {
        show(payload) {
            this.isShow = true
            this.type = payload.type
            this.currentChoosedVipGoods = payload.goods

            // showContentType表示含义： -999--》 表示用户参加自己分享的团 -998--》从订单中心查看团订单
            this.showContentType = payload.showContentType
            if (this.showContentType === -999) {
                this.afterPaySuccShowContent = 4
            } else if (this.showContentType === -998) {
                this.afterPaySuccShowContent = 2
                this.getUserGroupInfo()
            } else {
                this.afterPaySuccShowContent = 1
                this.createOrder()
            }
        },
        close() {
            if (this.showContentType === -998) {
                this.$EventBus.$emit('loop-query-group-order')
                this.showContentType = ''
            }
            this.showContentType = ''
            this.createOrderData = {}
            this.isShow = false
            this.type = -1
            this.payStatus = ''
            this.loading = true
            this.showBlank = false
            this.queryTimes = 0
            this.errorTimes = 0
            this.currentChoosedVipGoods = {}
            this.group_id = 0
            this.afterPaySuccShowContent = 1
            this.userGroupInfo = {}
            this.leftTime = 0
            this.countdownStr = '000000'
            this.showShareLink = false
            this.queryGroupInfoTimes = 0
            this.refreshTime = 15
            this.order_status = -1
            this.cancelRequest()
            clearTimeout(this.queryStatusTimeId)
            clearTimeout(this.queryRetryTimeId)
            clearTimeout(this.loopQueryGroupInfoTimeId)
            clearTimeout(this.queryJoinerGroupInfoTimeId)
            clearInterval(this.refreshPageTimeId)
        },
        // 创建订单
        createOrder() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.createOrder()
                    }
                })
            }

            const group_id = this.currentChoosedVipGoods.group_id
            const data = {
                g_id: this.currentChoosedVipGoods.id,
                channel: this.$Utils.getNowChannel(),
                pay_by: '',
                client_ip: this.$store.state.client_ip,
                type: 0,
                location_gid: 0,
                group_type: this.type === 1 ? 0 : group_id > 0 ? 2 : 1,
                group_id: this.currentChoosedVipGoods.group_id || 0
            }
            const { showOriginPrice, original_price } = this.currentChoosedVipGoods
            let current_price = showOriginPrice ? original_price : this.currentChoosedVipGoods.current_price
            if (this.type === 2) {
                current_price = this.currentChoosedVipGoods.group_price
            }
            this.loading = true
            this.createOrderData = data
            this.$refs['goods-qrcode'] && (this.$refs['goods-qrcode'].innerHTML = '')
            createVipOrder(data)
                .then((res) => {
                    this.loading = false
                    if (res && this.$Utils.isObject(res.data)) {
                        let url = config.WEB_DOMAIN + `/commonPay.html?orderId=${res.data.id}&orderPrefix=BOX&orderMoney=${current_price}`
                        const { id } = res.data
                        this.orderId = id
                        this.creatQrCode(url)
                        this.queryStatus(id)
                        this.current_price = current_price
                    } else {
                        this.$Toast.show(res.msg)
                    }
                })
                .catch((err) => {
                    // 长时间停留在会员页面，此时token已经过期了
                    if (err.response && err.response.status === 401) {
                        this.$Login.show()
                    }
                    this.loading = false
                })
        },
        // 创建二维码
        creatQrCode(url) {
            console.log('支付地址=======>', url)
            this.qrcode = new QRCode(this.$refs['goods-qrcode'], {
                text: url,
                width: 120,
                height: 120,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.showBlank = true

            this.$nextTick(() => {
                this.$refs['goods-qrcode'].title = ''
            })
        },
        // 查询订单状态
        queryStatus(orderId) {
            clearTimeout(this.queryStatusTimeId)
            clearTimeout(this.queryRetryTimeId)
            if (!orderId) {
                return false
            }

            let timeCell = 1000
            this.queryTimes++

            // 根据查询的次数
            if (this.queryTimes < 60) {
                timeCell = 1000
            } else if (this.queryTimes < 120) {
                timeCell = 1500
            } else if (this.queryTimes < 180) {
                timeCell = 2000
            } else if (this.queryTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }
            queryOrderStatus({ orderId, orderPrefix: 'BOX' })
                .then(async (res) => {
                    if (res.code == 200 && this.$Utils.isObject(res.data)) {
                        const { status } = res.data
                        if (!status) {
                            // 未支付
                            this.queryStatusTimeId = setTimeout(() => {
                                this.queryStatus(orderId)
                            }, timeCell)
                        } else if (status == 1) {
                            // 支付成功
                            if (this.type === 2) {
                                if (this.createOrderData.group_id > 0) {
                                    // 团员加入团查询
                                    this.loopJoinerGroupInfo(this.createOrderData.group_id)
                                } else {
                                    // 团长创建开团订单成功
                                    this.afterPaySuccShowContent = 2
                                    await this.$Utils.sleep(1500)
                                    this.getUserGroupInfo()
                                }
                            } else {
                                this.$Toast.show('支付成功')
                            }
                            this.isShowPayStatus = true
                            this.payStatus = 'succ'
                            this.queryTimes = 0
                            this.errorTimes = 0
                            clearInterval(this.queryStatusTimeId)
                            clearInterval(this.queryRetryTimeId)

                            const bd_vid = this.$cookies.get('bd_vid')
                            if (bd_vid) {
                                this.$Utils.report({ event: 'ocpc上报', event_id: 40, n2: 0, v1: 'pay', v2: bd_vid, v3: 'box_web', f1: this.current_price })
                            }
                        } else {
                            this.payStatus = 'fail'
                        }
                    } else {
                        // 查询接口非200状态码
                        this.queryStatusTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, timeCell)
                    }
                })
                .catch(() => {
                    // 网络错误、服务器挂了等其他情况，3s后重试，重试次数最大60次
                    this.errorTimes++
                    if (this.errorTimes < 60) {
                        this.queryRetryTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, 3000)
                    } else {
                        this.$Toast.show('网络错误')
                    }
                })
        },
        payAgain() {
            this.queryTimes = 0
            this.errorTimes = 0
            this.payStatus = ''
            this.isShowPayStatus = false
            this.createOrder()
        },
        // 取消创建订单和查询订单请求
        cancelRequest() {
            cancelRequest('/box/member/createOrder')
            cancelRequest('/order/getOrderStatus')
        },
        watchOrder() {
            $('.common-bottom').hide()
            this.isShow = false
            this.$ActSwitchDialog.hide()
            this.$router.push('/profile?id=2')
        },
        handlerClickShareBtn() {
            this.showShareLink = true
        },
        copyLink() {
            this.$Utils.copy(this.shareLink)
        },
        dlBox() {
            // 通知到App.vue里面去下载
            this.$EventBus.$emit('app-dl')
        },
        // 获取用户的参团信息
        getUserGroupInfo(flag) {
            getUserGroupInfo().then((res) => {
                if (res.code === 200 && this.$Utils.isObject(res.data)) {
                    this.userGroupInfo = res.data
                    this.$EventBus.$emit('update-group-info', res.data)
                    if (flag !== 'no-query') {
                        const id = res.data?.latest_main?.id
                        id && this.loopJoinerGroupInfo(id)
                    }
                }
            })
        },
        // 循环查询参团人的加入这个团的信息
        loopJoinerGroupInfo(id) {
            clearTimeout(this.queryJoinerGroupInfoTimeId)
            if (id < 0) {
                return false
            }
            let timeCell = 1000
            this.queryGroupInfoTimes++

            // 根据查询的次数
            if (this.queryGroupInfoTimes < 60) {
                timeCell = 1000
            } else if (this.queryGroupInfoTimes < 120) {
                timeCell = 1500
            } else if (this.queryGroupInfoTimes < 180) {
                timeCell = 2000
            } else if (this.queryGroupInfoTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }
            getGroupInfo({ id })
                .then((res) => {
                    if (res.code === 200 && this.$Utils.isObject(res.data)) {
                        const { status, order_status } = res.data
                        this.order_status = order_status
                        // 在订单中心打开查看"拼团订单"，订单状态变更了通知订单组件
                        this.$EventBus.$emit('update-group-order', res.data)
                        if (status === 0 || status === 1) {
                            this.queryJoinerGroupInfoTimeId = setTimeout(() => {
                                this.loopJoinerGroupInfo(id)
                            }, timeCell)
                        } else if (status === 2) {
                            // 团的状态是成功的
                            if (this.orderStatus.indexOf(order_status) > -1) {
                                this.afterPaySuccShowContent = 3
                                this.groupSuccAfter()
                            } else {
                                this.afterPaySuccShowContent = 4
                                this.refreshPage()
                            }
                        } else if (status === 3) {
                            this.afterPaySuccShowContent = 4
                            this.refreshPage()
                        }
                    }
                })
                .catch((err) => {
                    console.log('[judgeCurrentGroupInfoIsValid]=======>', err)
                })
        },
        // 拼团成功后
        groupSuccAfter() {
            if (this.judgeEnv === 'box_website') {
                const path = this.$router.currentRoute.path
                if (path === '/group') {
                    // 在邀请页面
                    this.$EventBus.$emit('refresh-group-info')
                } else {
                    // 在开团活动弹框里面
                    this.$EventBus.$emit('change-act-nav', '')
                    setTimeout(() => {
                        this.$EventBus.$emit('change-act-nav', 'ActGroupBuyVip')
                    }, 50)
                }
            } else {
                this.$EventBus.$emit('subpage-notify-refresh')
            }
        },
        // 拼团失败
        refreshPage() {
            this.refreshPageTimeId = setInterval(() => {
                this.refreshTime--
                if (this.refreshTime <= 0) {
                    clearInterval(this.refreshPageTimeId)
                    this.groupSuccAfter()
                    this.close()
                    return false
                }
            }, 1000)
        }
    }
}
</script>

<style lang="less" scoped>
.buy-group-vip-page {
    .buy-group-vip-content {
        padding: 60px 0 0;
        width: 545px;
        height: 464px;
        background: url(../../../assets/dialog/buy-dialog-bg.png) center/100% no-repeat;
        letter-spacing: 0;

        .close-icon {
            width: 20px;
            height: 20px;
            background: url(../../../assets/dialog/close-icon.png) center/100% no-repeat;

            &:hover {
                background-image: url(../../../assets/dialog/close-icon.png);
            }
        }

        .dialog-title {
            margin: 0 auto 30px;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            line-height: 30px;
            background: linear-gradient(90deg, #d67003 0%, #703b02 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .order-info-wrap {
            display: flex;
            margin: 0 auto;
            padding: 14px;
            width: 425px;
            height: 115px;
            border-radius: 8px;
            background: #fffdf9;

            .goods-info {
                position: relative;
                width: 164px;
                height: 86px;

                .icon {
                    position: absolute;
                    z-index: 1;
                    top: -9px;
                    right: -12px;
                    width: 55px;
                    height: 40px;
                    background: url(../../../assets/dialog/diamond-s-icon.png) center/100% no-repeat;
                }

                .inner {
                    position: relative;
                    width: 164px;
                    height: 86px;

                    &.vip1 {
                        background: url(../../../assets/dialog/vip1-s.png) left top no-repeat;

                        .dv1 {
                            background: linear-gradient(90deg, #a45d1b 4.91%, #835d39 99.84%);
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        .dv2 {
                            .sp1 {
                                color: #a45d1b;
                            }

                            .sp2 {
                                color: rgba(164, 93, 27, 0.5);

                                &::after {
                                    background-color: rgba(164, 93, 27, 0.5);
                                }
                            }
                        }

                        .dv4 {
                            color: rgba(164, 93, 27, 0.8);
                            border: 1px solid #e6ad5c;
                        }
                    }

                    &.vip2 {
                        background: url(../../../assets/dialog/vip2-s.png) left top no-repeat;

                        .dv1 {
                            background: linear-gradient(90deg, #ffe4ca 2.34%, #fffefd 100%);
                            background-clip: text;
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        .dv2 {
                            .sp1 {
                                color: #ffe5cd;
                            }

                            .sp2 {
                                color: #ffe4ca;

                                &::after {
                                    background-color: #ffe4ca;
                                }
                            }
                        }

                        .dv4 {
                            width: 130px;
                            color: #8a95b2;
                            border: 1px solid #808aa2;
                        }
                    }

                    &.vip3 {
                        background: url(../../../assets/dialog/vip3-s.png) left top no-repeat;

                        .dv1 {
                            color: rgb(119, 95, 201);
                        }

                        .dv2 {
                            .sp1 {
                                color: #775fc9;
                            }

                            .sp2 {
                                color: rgba(119, 95, 201, 0.5);

                                &::after {
                                    background-color: rgba(119, 95, 201, 0.5);
                                }
                            }
                        }

                        .dv4 {
                            color: rgba(119, 95, 201, 0.8);
                            border: 1px solid #afa6e9;
                        }
                    }

                    .dv1 {
                        padding-top: 13px;
                        text-align: center;
                        font-size: 12px;
                        font-weight: 700;
                    }

                    .dv2 {
                        margin-top: 4px;
                        text-align: center;

                        .sp1 {
                            .i0 {
                                position: relative;
                                font-size: 8px;
                                line-height: 12px;
                                margin: 0 4px;
                                top: -1px;
                            }

                            .i1 {
                                font-size: 10px;
                                font-weight: 700;
                                line-height: 15px;
                                margin-right: 2px;
                            }

                            .i2 {
                                margin-right: 4px;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 900;
                            }
                        }

                        .sp2 {
                            position: relative;
                            font-size: 8px;
                            font-weight: 400;
                            line-height: 12px;

                            i:first-child {
                                margin-right: 4px;
                            }

                            &::after {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%);
                                content: '';
                                width: 105%;
                                height: 1px;
                            }
                        }
                    }

                    .dv4 {
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 120px;
                        height: 12px;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 5px;
                        border-radius: 2px;
                        font-size: 6px;
                    }
                }
            }

            .price-info {
                margin: 0 0 10px 17px;
                padding-top: 7px;
                flex: 1;

                .dv1 {
                    color: #683907;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    margin-bottom: 10px;
                }

                .dv2 {
                    .sp1 {
                        color: #ea3b3b;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                    }

                    .sp2 {
                        margin: 0 5px 0 2px;
                        color: #ea3b3b;
                        font-weight: 900;

                        .i0 {
                            font-size: 16px;
                        }

                        .i1 {
                            font-size: 24px;
                        }
                    }

                    .sp3 {
                        color: #916e38;
                        font-size: 14px;
                        font-weight: 900;
                        line-height: normal;
                        text-decoration-line: line-through;
                    }
                }
            }
        }

        .pay-section {
            margin-top: 30px;
            display: flex;
            padding: 0 0 0 60px;

            .pay-left {
                margin-right: 16px;

                .qrcode-wrap {
                    width: 134px;
                    height: 134px;
                    position: relative;
                    border-radius: 8px;
                    border: 1px solid #854602;

                    .qrcode-section {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 2;
                        background-color: @color-txt-high;
                        border-radius: 8px;
                        border: 1px solid #ebebeb;

                        .goods-qrcode {
                            position: absolute;
                            width: 120px;
                            height: 120px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);

                            ::v-deep img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .qrcode-loading {
                        position: absolute;
                        z-index: 3;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: #fff;
                        border-radius: 8px;

                        .icon {
                            width: 32px;
                            height: 32px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            background: url(../../../assets/dialog/loading.gif) center/100% no-repeat;
                        }
                    }

                    .qrcode-succ,
                    .qrcode-invalid {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: linear-gradient(#000000b3, #000000b3);
                        z-index: 3;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-radius: 9px;

                        .dv1 {
                            text-align: center;
                            line-height: 23px;
                            color: @color-txt-high;
                            font-size: 14px;
                        }

                        .dv2 {
                            margin: 17px auto 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 60px;
                            height: 24px;
                            border-radius: 12px;
                            background: linear-gradient(90.64deg, #ffe0c1 0.41%, #f2ab74 100.09%);
                            color: #6b3d1e;
                            font-weight: 600;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .pay-right {
                padding-top: 21px;
                flex: 1;

                .price-wrap {
                    font-weight: bold;
                    font-size: 14px;

                    .sp0 {
                        color: #916e38;
                    }

                    .sp1,
                    .sp2 {
                        color: #ea3b3b;
                    }

                    .sp1 {
                        margin-left: 4px;
                        font-size: 16px;
                    }

                    .sp2 {
                        font-size: 40px;
                    }
                }

                .goods-decs-wrap {
                    margin-top: 20px;
                    text-align: left;

                    .info-wrap {
                        .info-item {
                            &:nth-child(1) {
                                margin-bottom: 10px;
                            }

                            span {
                                font-size: 14px;
                            }

                            .field {
                                color: @color-txt-normal;
                                margin-right: 10px;
                            }

                            .field-value {
                                color: @color-txt-high;
                            }
                        }
                    }
                }

                .pay-icon-wrap {
                    padding-top: 4px;

                    .dv1 {
                        display: flex;
                        align-items: center;
                        font-size: 0;
                        width: 310px;
                        height: 18px;

                        span {
                            font-size: 12px;
                            color: #916e38;
                            display: inline-block;
                            margin: 0 4px 0 0;
                            vertical-align: middle;

                            &:last-child {
                                margin-right: 0;
                            }
                        }

                        .icon {
                            width: 16px;
                            height: 16px;

                            &.wx-icon {
                                background: url(../../../assets/dialog/wx-icon.png) center no-repeat;
                                background-size: 100% 100%;
                            }

                            &.zfb-icon {
                                background: url(../../../assets/dialog/zfb-icon.png) center no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }

                .agree {
                    text-align: left;
                    font-size: 14px;
                    line-height: 20px;

                    i {
                        color: #916e38;
                        margin-right: 1px;
                    }

                    span {
                        margin: 0 5px;
                        color: rgba(145, 110, 56, 0.5);
                    }

                    a {
                        text-decoration: none;
                        color: #874602;
                        cursor: pointer;
                    }
                }
            }
        }

        .group-vip-order {
            margin: 20px auto 0;

            .dv1 {
                text-align: center;
                color: #331e07;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;

                span {
                    color: #ea3b3b;
                }
            }

            .countdown {
                margin-top: 9px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: rgb(255, 255, 255);

                .sp1 {
                    text-align: center;
                    line-height: 22px;
                    font-size: 16px;
                    width: 36px;
                    height: 22px;
                    background: url(../../../assets/act/countdown-icon.png) center/100% no-repeat;
                }

                .sp2 {
                    width: 10px;
                    font-size: 20px;
                    font-weight: 900;
                    margin-top: -4px;
                    padding-left: 2px;
                }

                .sp3 {
                    margin-left: 4px;
                    color: rgb(145, 110, 56);
                    font-size: 14px;
                    line-height: 22px;
                }
            }

            .invite-info {
                padding-top: 21px;
                display: flex;
                flex: 1;
                justify-content: center;

                .item1,
                .item2 {
                    background: url(../../../assets/act/invite-btn.png) center/100% no-repeat;

                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                .item1 {
                    position: relative;
                    margin-right: 24px;
                    width: 60px;
                    height: 60px;
                    border: 1px solid #f8e3c2;
                    border-radius: 50%;

                    .icon {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 48px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 46px;
                        height: 20px;
                        border-radius: 10px;
                        border: 1px solid #faf7f2;
                        background: #ea3b3b;
                        color: #ffffff;
                        font-size: 12px;
                    }
                }

                .item2 {
                    width: 60px;
                    height: 60px;
                }
            }

            .share-btn {
                cursor: pointer;
                margin: 20px auto 0;
                width: 228px;
                height: 53px;
                color: #ffffff;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                line-height: 53px;
                background: url(../../../assets/act/share-btn.png) center/100% no-repeat;
            }

            .share-link-section {
                position: relative;
                margin: 21px auto 0;
                padding: 9px 14px;
                display: flex;
                width: 425px;
                height: 54px;
                border-radius: 8px;
                border: 1px solid #f1be3f;
                background: #fae6c5;
                font-size: 12px;
                color: #683907;

                .copy-btn {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    bottom: 6px;
                    right: 22px;
                    cursor: pointer;
                    color: #ffffff;
                    text-align: center;
                    font-size: 12px;
                    line-height: 30px;
                    width: 52px;
                    height: 20px;
                    border-radius: 10px;
                    background: linear-gradient(97deg, #ffc363 -4.41%, #be3f10 74.85%);
                    box-shadow: 0 4px 10px 0 #e9c690 inset;
                }
            }
        }

        .group-succ,
        .group-fail,
        .my-own-group {
            margin: 60px auto 0;

            .text {
                color: #331e07;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                line-height: 24px;
            }

            .text1 {
                span {
                    color: #ea3b3b;
                }
            }

            .dl-btn {
                cursor: pointer;
                margin: 80px auto 0;
                width: 228px;
                height: 53px;
                color: #ffffff;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                line-height: 53px;
                background: url(../../../assets/act/share-btn.png) center/100% no-repeat;
            }
        }
    }
}
</style>
